import './index.css';
import { useState } from 'react';
import CustomerCallChat from '../../components/CustomerCallChat';
import CustomerCallContainer from '../../components/CustomerCallContainer';
import ChatStore from '../../stores/ChatStore';
import EndCallByTechForCustomer from '../../components/EndCallByTechForCustomer';

export default function CustomerCallView() {

  const [chatIsOpen, setChatIsOpen] = useState(false);
  const [client, setClient] = useState(null);
  const handleChatIsOpen = () => {
    setChatIsOpen(!chatIsOpen);
    ChatStore.setUnreadMessages(0);
  }

  return (
    <div className="customer-call-view">
      <CustomerCallContainer handleChatIsOpen={handleChatIsOpen} chatIsOpen={chatIsOpen} setChatIsOpen={setChatIsOpen} setClient={setClient} />
      {chatIsOpen && <CustomerCallChat handleChatIsOpen={handleChatIsOpen} />}
      <EndCallByTechForCustomer client={client} />
    </div>
  );
}